class VideoPopup extends HTMLElement {
  constructor(){
    super();
    document.getElementById('SortPopOverflowMist').addEventListener('click', e => this.closePopup(this));
    const VideoPop = this.querySelectorAll('[jsVideoPopup]');
    for(let i=0; i<=VideoPop.length; i++){
      if(VideoPop[i]){VideoPop[i].addEventListener('click',this.PopupToggler.bind(this))}
    }
  }
  PopupToggler(event){
    event.preventDefault();
    var iframeSrc = this.querySelector('.JPS_VDO-ItemIcon').getAttribute('iframeSrc'), iframe = document.createElement('iframe');
    iframe.src = iframeSrc; iframe.classList.add('iframeActivated');
    if(!this.querySelector('.iframeActivated')){
      this.querySelector('.JPS_VDO-ItemMainIn').appendChild(iframe);
    }
    this.querySelector('.JPS_VDO-ItemCntnr').classList.add('JPSCurrentVDOPop')
    document.body.classList.add('HomeVideoPopupInit');
  }
  closePopup(){
    var iframeSrc = this.querySelector('.JPS_VDO-ItemCntnr iframe').getAttribute('src');
    this.querySelector('.JPS_VDO-ItemCntnr').classList.remove('JPSCurrentVDOPop');
    this.querySelector('.JPS_VDO-ItemCntnr iframe').setAttribute('src',iframeSrc)
    document.body.classList.remove('HomeVideoPopupInit');
    this.querySelector('.JPS_VDO-ItemMainIn').innerHTML = ''
  }
}
customElements.define('video-popup', VideoPopup)